import React from 'react';
import { Breadcrumb } from '../components/common/Breadcrumb';
import { ContractorsForm } from '../components/contractors/ContractorsForm';
import { ContractorsTable } from '../components/contractors/ContractorsTable';
const breadcrumbItems = [{
  label: 'Configuración',
  href: '#'
}, {
  label: 'Gestión de Contratistas'
}];
export const Contractors = () => {
  return <div className="min-h-screen bg-gray-50" data-id="element-1370">
      <main className="pt-16 pl-64" data-id="element-1371">
        <div className="max-w-7xl mx-auto p-8" data-id="element-1372">
          <div className="mb-8" data-id="element-1373">
            <Breadcrumb items={breadcrumbItems} data-id="element-1374" />
            <h1 className="text-2xl font-bold text-gray-900 mt-4" data-id="element-1375">
              Gestión de Contratistas
            </h1>
          </div>
          <div className="bg-white rounded-lg shadow mb-8" data-id="element-1376">
            <div className="p-6" data-id="element-1377">
              <h2 className="text-lg font-medium text-gray-900 mb-6" data-id="element-1378">
                Registro de Contratista
              </h2>
              <ContractorsForm data-id="element-1379" />
            </div>
          </div>
          <ContractorsTable data-id="element-1380" />
        </div>
      </main>
    </div>;
};